<template>
    <div class="dropdown-filter">
        <span class="dropdownTitle">{{ title }}</span>
        <button class="dropdown-button" @click="toggleDropdown">
          <span class="NofFilter" v-if="selectedItems.length>0">{{ selectedItems.length }}</span>  {{ placeholder }}
        </button>
        <div v-show="isOpen" class="dropdown-list">
            <div v-for="item in items" :key="item.id" class="item" >
                <input type="checkbox" :id="item.name" v-model="item.checked" @change="handleToggleBox(item)">
                <label :for="item.name" class="dropdownLabel">{{ item.name }}</label>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'DropdownFilter',
    props: {
        title: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            isOpen: false,
            selectedItems: [],
            isReset: 0,
        };
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },

        handleToggleBox(item){
        //    item.checked = !item.checked; // Toggle the checked state

            const itemIndex = this.selectedItems.findIndex(selectedItem => selectedItem.id === item.id);
            if(itemIndex !== -1) {
                this.selectedItems.splice(itemIndex, 1);
            } else {
                this.selectedItems.push(item);
            }

            console.log(this.selectedItems);
            this.$emit('item-toggled', item);
        },

        closeDropdown() {
            this.isOpen = false;
        },
    },
    mounted() {
       if(this.isReset==0){this.items.forEach(item => item.checked = false);}
        this.isReset=1
    }
}
</script>

<style scoped>
.dropdown-filter {
    width: 168px;
    position: relative;
}

.dropdownTitle{
    color: #333;
    font-family: "Barlow", Sans-serif;
    font-size: 17px;
    font-weight: 400;
    text-wrap: nowrap;
}

.dropdown-filter .dropdown-button {
    width: 100%;
    display: flex;
    text-align: left;
    padding: 0.5rem 1rem;
    font-weight: 400;
    color: #016d89;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    background-color: transparent;
    border-radius: 8px;
    background: #428DA1;
    color: white;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    border-radius: 4px;
    transition: all .3s;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    border: none;
}

.dropdown-filter .dropdown-list {
    width: 100%;
    padding: 0.5rem 0;
    box-sizing: border-box;
    position: absolute;
    top: 100%;
    left: 0;
    border: 1px solid #ddd;
    background-color: #fff;
    z-index: 10;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.dropdown-filter .dropdown-list .item {
    padding: 0.5rem 1rem;
    display: flex;
}

.dropdown-filter .dropdown-list .item input[type="checkbox"] {
    margin-right: 0.5rem;
}

.dropdownLabel{
    font-family: "Barlow", Sans-serif;
    font-weight: 500;
    color:#016d89;
}

.NofFilter {
    background-color: #016d89;
    padding: 9px;
    margin-right: 8px;
    border-radius: 50%;
    color: white;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// src/components/DropdownFilter.vue